export default "__VITE_ASSET__CW6FviRm__"